import { useI18n } from 'next-localization';

import { cn } from '@/lib/utils';
import { NeuButton, NeuIcon } from '@hcahealthcaredpx/neutron-react';

import styles from '../../../booking.module.css';

export const NoTimeslots = ({ locationPhone }: { locationPhone: string }): JSX.Element => {
  const { t } = useI18n();
  return (
    <div className={cn('text-center', styles.ctaCalendarButton)}>
      {locationPhone ? (
        <>
          <p className="m-0">{t('OAS.Booking.Appointment.NoAvailableTimeslots')}</p>
          <NeuButton kind="primary" id="calendar-call-to-make-appointment">
            <NeuIcon name="call" /> {locationPhone}
          </NeuButton>
        </>
      ) : (
        <div>{t('OAS.Booking.Appointment.NoTimeslots')}</div>
      )}
    </div>
  );
};
